import ddt from '@wix/da-ddt';
import { EditorFeature } from './types';
import findIndex from 'lodash/findIndex';

export function getFeature(type: string, features: EditorFeature[] | string) {
  if (typeof features === 'string') {
    try {
      features = JSON.parse(features);
    } catch (e) {
      ddt.error('tiptap', 'Failed to parse features', e);
    }
  }
  if (typeof features === 'string') {
    return; // TS..
  }
  const idx = findIndex(features, ['type', type]);
  return features[idx] || undefined;
}
